<template>
    <div class="timeout-layout" style="font-family: Arial, sans-serif;">
        <match-info-header :match="match" class="slide-in-left slide-in-delayed" />
        <div v-if="$scopedSlots['bottom-left']" class="bottom-left-slot slide-in-left slide-in-delayed">
            <slot name="bottom-left" />
        </div>
        <div class="timeout-side-left slide-in-left" />
        <div class="timeout-center" :class="{ 'timeout-center-bottom': contentAlign === 'bottom' }">
            <div class="center-card font-weight-bold slide-in-right slide-in-delayed">
                <slot />
            </div>
        </div>
        <div class="timeout-side-right slide-in-right" />
    </div>
</template>

<script>
    import MatchInfoHeader from '@/components/MatchInfoHeader.vue'

    export default {
        name: 'BroadcastScreenLayout',
        components: {
            MatchInfoHeader
        },
        props: {
            match: {
                type: Object,
                default: () => ({})
            },
            contentAlign: {
                type: String,
                default: 'center'
            }
        }
    }
</script>

<style scoped>
.timeout-layout {
    display: flex;
    min-height: 100vh;
    position: relative; /* anchor absolute header */
    overflow: visible;

    /* 1.8x bigger */
    --cell-size: clamp(50px, 9vw, 86px);
    --font-size: clamp(21.6px, 3.24vw, 32.4px);
    --label-font-size: clamp(18px, 2.88vw, 28.8px);
    --gap: clamp(14px, 2.7vw, 36px);

    font-size: var(--font-size) !important;
}

/* Anchored to the bottom of the left column, aligned with the match info header */
.bottom-left-slot {
    position: absolute;
    left: 105px;
    bottom: 48px;
    z-index: 5;
}

.timeout-side-left {
    flex: 0 0 20%;
    max-width: 20%;
    background-color: #ff7a00;
    opacity: 0.8;
    z-index: 1;
}

.timeout-side-right {
    flex: 0 0 25%;
    max-width: 25%;
    background-color: #ff7a00;
    opacity: 0.8;
    z-index: 1;
}

.timeout-center {
    display: flex;
    align-items: center;
    justify-content: center;
    flex: 1 1 auto;
    padding: 16px;
    position: relative;
    z-index: 2;
    overflow: visible;
}

.timeout-center-bottom {
    align-items: flex-end;
    padding-bottom: 48px;
}

.center-card {
    display: inline-block;
    position: relative;
    z-index: 3;
}

/* Left-hand elements slide in left -> right, right-hand ones right -> left */
.slide-in-left {
    animation: slideInFromLeft 0.7s cubic-bezier(0.22, 1, 0.36, 1) both;
}

.slide-in-right {
    animation: slideInFromRight 0.7s cubic-bezier(0.22, 1, 0.36, 1) both;
}

.slide-in-delayed {
    animation-delay: 0.2s;
}

@keyframes slideInFromLeft {
    from { transform: translateX(-100vw); }
    to { transform: translateX(0); }
}

@keyframes slideInFromRight {
    from { transform: translateX(100vw); }
    to { transform: translateX(0); }
}

.center-card ::v-deep .v-card {
    box-shadow: 0 10px 30px rgba(0, 0, 0, 0.3);
    border-radius: 16px;
}
</style>
